/**
 * Created by Lucas on 07-May-18.
 */

import axios from "axios";
import configs from "./configs";
import Vue from "vue";

export function getAxios() {
  var axiosMock = axios.create({
    headers: {
      Authorization: `Bearer ${localStorage.getItem("token")}`,
      "api-region": localStorage.getItem("region") || 'BR',
      "X-refresh-token": localStorage.getItem("X-refresh-token") || '',
      "X-refresh-id": localStorage.getItem("userid") || '',
    },
    baseURL: configs.API_URL,
  });

  return axiosMock
}

export default {
  run(context, url, successCallback, errorCallback, method, data) {
    let config = {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "api-region": localStorage.getItem("region") || 'BR',
        "Content-Type": "multipart/form-data"
      },
    };

    let axiosInstance = null;
    switch (method) {
      case "post":
        axiosInstance = axios.post(configs.API_URL + url, data, config);
        break;
      case "put":
        axiosInstance = axios.put(configs.API_URL + url, data, config);
        break;
      default:
        axiosInstance = axios.get(configs.API_URL + url, config);
    }

    axiosInstance
      .then((response) => {
        let data = response.data;
        if (successCallback) {
          successCallback(data);
        }
      })
      .catch((error) => {
        console.log(error);
        if (error.response) {
          if (error.response.status === 401) {
            context.$router.push(`/notlogged`);
          }
        }
        if (errorCallback) {
          errorCallback(error);
        }
      });
  },
};



// WEBPACK FOOTER //
// ./src/services/ajaxFile.js